import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'chevron-left-pipe', 'IconChevronLeftPipe', [["path",{"d":"M7 6v12","key":"svg-0"}],["path",{"d":"M18 6l-6 6l6 6","key":"svg-1"}]]);